import { useCreate } from '@/store/create';
import { LeadFormModal } from '../crm/LeadFormModal';
import { ClientFormModal } from '../crm/ClientFormModal';
import { TaskFormModal } from '../tasks/TaskFormModal';
import { EmployeeFormModal } from '../hrm/EmployeeFormModal';

/** Quick-create modals shared by the top bar and detail pages. */
export function CreateModals() {
  const { open, defaults, close } = useCreate();
  return (
    <>
      <LeadFormModal open={open === 'lead'} onClose={close} />
      <ClientFormModal open={open === 'client'} onClose={close} />
      <TaskFormModal open={open === 'task'} onClose={close} related={defaults.related as { type: 'lead' | 'client' | 'project'; id: string; name: string } | undefined} />
      <EmployeeFormModal open={open === 'employee'} onClose={close} />
    </>
  );
}
